import styled from 'styled-components';
import { media } from '~src/styles/media-templates';

export const FormTitle = styled.div`
  color: ${({ theme }) => theme.white.a10};
  font-size: 3rem;
  text-align: center;
  align-self: start;
  ${media.tablet`
    font-size: 2rem;
  `}
  ${media.phone`
    font-size: 2rem;
  `}
`;
